import { Route, Routes } from "react-router-dom";
import AnalyzeOrder from './Pages/AnalyzeOrder';
import Home from "./Pages/HomePage";
import AnalyzeProducts from "./Pages/AnalyzeProducts";
import AnalyzeNewProducts from './Pages/analyze2026/AnalyzeNewProducts';
import AnalyzeNewProductsUnits from './Pages/analyze2026/AnalyzeNewProductsUnits';

function NavBar({ jwt }) {

  return <div>
    <Routes>
      <Route path="/*" element={<Home />} />
      <Route path="/dynamicOrder" element={<AnalyzeOrder jwt={jwt} />} />
      <Route path="/sell" element={<AnalyzeProducts jwt={jwt} />} />
      <Route path="/newsell" element={<AnalyzeNewProducts jwt={jwt} />} />
      <Route path="/newsellinunits" element={<AnalyzeNewProductsUnits jwt={jwt} />} />
    </Routes>
  </div>;
}

export default NavBar;